import { create } from 'zustand';
import type { SessionData } from '@/utils/types';

interface SessionState {
  data: SessionData | null;
  loading: boolean;
  error: string | null;
  isValid: boolean;
  timestamp: number;
  isLoggingOut: boolean;

  setSession: (data: SessionData) => void;
  clearSession: () => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setValid: (isValid: boolean) => void;
  setLoggingOut: (value: boolean) => void;
}

export const useSessionStore = create<SessionState>(set => ({
  data: null,
  loading: true,
  error: null,
  isValid: false,
  timestamp: 0,
  isLoggingOut: false,

  setSession: data =>
    set({
      data,
      error: null,
      isValid: true,
      timestamp: Date.now(),
    }),

  clearSession: () =>
    set({
      data: null,
      loading: false,
      error: null,
      isValid: false,
      timestamp: 0,
    }),

  setLoading: loading => set({ loading }),

  setError: error => set({ error }),

  setValid: isValid => set({ isValid }),

  setLoggingOut: (value: boolean) => set({ isLoggingOut: value }),
}));

export const getSessionState = () => useSessionStore.getState();

export const updateSessionData = (sessionData: SessionData) => {
  const { setSession } = useSessionStore.getState();
  setSession(sessionData);
};

export const clearSessionData = () => {
  const { clearSession } = useSessionStore.getState();
  clearSession();
};
